import { AppState } from "../../../redux-configuration/AppState";
import { PaymentStatus } from "../../domain/entities/types/subscription.type";

export const paymentStatusSelector = (appState: AppState): PaymentStatus | undefined => appState.payment.validatePayment.status
export const validatePaymentLoadingSelector = (appState: AppState): boolean => appState.payment.validatePayment.loading
export const validatePaymentErrorSelector = (appState: AppState): string | undefined => appState.payment.validatePayment.error
